import { render, staticRenderFns } from "./BoardDivider.vue?vue&type=template&id=6ab76a62"
import script from "./BoardDivider.vue?vue&type=script&lang=js"
export * from "./BoardDivider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports